import React from 'react';

type Props = {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  rightSlot?: React.ReactNode;
};

const TableToolbar: React.FC<Props> = ({ value, onChange, placeholder = 'Filter…', rightSlot }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '8px 0' }}>
      <input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ padding: '6px 10px', border: '1px solid #CBD5E1', borderRadius: 6, minWidth: 220 }}
      />
      {rightSlot}
    </div>
  );
};

export default TableToolbar;

